class CommissionBlock {
    constructor(addLink) {
        this.addLink = addLink;
        this.block = {
            element: this.addLink.parentNode,
            classes: ["bgc-lighter", "bs-light", "p-1"],
        };
        this.rowsContainer = undefined;

        this.addLink.addEventListener("click", this.addNewRow.bind(this));
    }

    hasFullStructure() {
        return this.block.classes
            .every(cssClass => this.block.element.classList.contains(cssClass));
    }

    removeFullStructure() {
        this.block.element.classList.remove(...this.block.classes);
        this.block.element.removeChild(this.rowsContainer.parentNode);
        this.rowsContainer = undefined;
    }

    removeRow(event) {
        if (event.target.classList.contains("delete-btn")) {
            this.rowsContainer.removeChild(event.target.parentNode);
            if (this.rowsContainer.childElementCount === 0) {
                this.removeFullStructure();
            }
        }
    }

    addRowsContainer() {
        this.block.element.insertAdjacentHTML("afterbegin", `
        <div id="${this.addLink.dataset.for}" class="d-f fd-r">
            <p class="fb-33c3 d-f jc-fe">${this.addLink.dataset.label}</p>
            <div class="fb-50"></div>
        </div>
        `);

        this.rowsContainer = this.block.element.querySelector(`#${this.addLink.dataset.for} > div`);
        this.rowsContainer.addEventListener("click", this.removeRow.bind(this));
    }

    buildFullStructure() {
        this.block.element.classList.add(...this.block.classes);
        this.addRowsContainer();
    }

    addNewRow() {
        if (!this.hasFullStructure()) {
            this.buildFullStructure();
        }
        this.rowsContainer.insertAdjacentHTML("beforeend", `
        <div class="d-f fd-r jc-sa pl-1c5 mb-1 ai-c">
            <input class="c-mid-darker p-0c5 out-n b-mid-1 br-5 b-item-selected:f" />
            <input class="c-mid-darker p-0c5 out-n b-mid-1 br-5 b-item-selected:f" />
            <span class="delete-btn"></span>
        </div>
        `);
    }
}

class CommissionSplit {
    constructor() {
        Array.from(document.getElementsByClassName("add-data")).forEach((element) => {
            // TODO: find a way to fix this eslint rule here
            new CommissionBlock(element); // eslint-disable-line no-new
        });
    }
}

export default CommissionSplit;
